module.exports = __webpack_public_path__ + "statics/img/bubble-android-11576a2f.png";


//////////////////
// WEBPACK FOOTER
// ./web/img/xhpopulrz/download/bubble-android.png
// module id = 1219
// module chunks = 143